<template>
  <v-container class="max-width-1200">
    <v-row>
      <v-col class="pb-0 headline text-uppercase">
        {{ $t('common.references') }}
      </v-col>
    </v-row>
    <v-row>
      <v-col class="display-1">
        {{ $t('common.learnAboutOurWork')}}
      </v-col>
    </v-row>

    <v-row class="text-center justify-center">
      <v-col
        v-for="(item,index) in studies"
        :key="index"
        cols="12" sm="6" md="4" lg="3">
        <v-hover v-slot="{ hover }">
          <v-card
            flat
            @click="openStudy(item)">
            <v-img
              height="300px"
              :src="item.img">
              <v-expand-transition>
                <div
                  v-if="hover"
                  class="d-flex transition-fast-in-fast-out primary darken-2 overlay-hover display-3 white--text"
                  style="height: 100%;">
                    {{ $t("common.readMore") }}
                </div>
              </v-expand-transition>
              <v-row class="white--text fill-height align-end overlay">
                <v-icon
                  v-if="actualStudy.id == item.id"
                  dark
                  class="icon-tile-mark">
                  mdi-bookmark
                </v-icon>
                <v-col cols="12" class="px-8 title text-start">
                  <!-- {{ item.title }} -->
                </v-col>
                <v-col v-if="!hover" cols="12" class="px-8 text-start">
                  <span class="title">{{ $t(item.title) }}</span><br>
                  <span class="overline">{{ $t("common.readMore") }}</span>
                </v-col>
              </v-row>
            </v-img>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <v-row id="studyText" class="mt-8 min-height-300">
      <v-expansion-panels
        v-model="panel"
        accordion
        flat>
        <v-expansion-panel
          v-for="(item,index) in studies"
          :key="index">
          <v-expansion-panel-content>
            <v-row>
              <v-col class="title">
                {{ $t(item.title) }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="title">
                {{ $t(item.subtitle) }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify">
                {{ $t(item.text) }}
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'References',
    extends: DataComponentBase,

    data: () => ({
      studies: [
        { id: "id0", index: 0,
          img: require("@/assets/img/it-reference-01.webp"),
          title: "case.energyMonitor.title",
          subtitle: "case.energyMonitor.subtitle",
          text: "case.energyMonitor.text"
        },
        // { id: "id1", index: 1,
        //   img: "https://www.rubin.hu/wp-content/uploads/2015/05/330.jpg",
        //   title: "case.admos.title",
        //   subtitle: "case.admos.subtitle",
        //   text: "case.admos.text"
        // },
        { id: "id1", index: 1,
          img: require("@/assets/img/it-reference-02.jpg"),
          title: "case.domino.title",
          subtitle: "case.domino.subtitle",
          text: "case.domino.text"
        },
        // { id: "id3", index: 2,
        //  img: require("@/assets/img/it-reference-01.webp"),
        //   title: "case.rescueCell.title",
        //   subtitle: "case.rescueCell.subtitle",
        //   text: "case.rescueCell.text"
        // },
        { id: "id4", index: 2,
          img: require("@/assets/img/it-reference-03.webp"),
          title: "case.livingWage.title",
          subtitle: "case.livingWage.subtitle",
          text: "case.livingWage.text"
        },
        { id: "id5", index: 3,
          img: require("@/assets/img/it-reference-04.jpeg"),
          title: "case.argus.title",
          subtitle: "case.argus.subtitle",
          text: "case.argus.text"
        },
      ],
      actualStudy: {
        id: "id0",
        title: "",
        text: "",
      },
      panel: 0,

    }),

    methods: {
      openStudy(study) {
        this.actualStudy.id    = study.id;
        this.actualStudy.title = study.title;
        this.actualStudy.text  = study.text;
        var panel = study.index;
        this.showStudy(panel, 'studyText')
      },
      showStudy(panel, id) {
        this.panel = panel;
        this.scrollTOSection(id);
      },
      scrollTOSection(id) {
        var section = document.getElementById(id);
        section.scrollIntoView();
      },
    },
  }
</script>
